var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.816 10.38h-8.632v3.33h5.05c-.091.81-.642 2.07-1.836 2.88-.735.54-1.837.9-3.214.9-2.388 0-4.5-1.53-5.235-3.78a5.696 5.696 0 0 1-.276-1.8c0-.63.092-1.26.276-1.8.092-.18.092-.36.184-.45.826-1.89 2.755-3.24 5.05-3.24 1.746 0 2.848.72 3.582 1.35l2.572-2.52C16.776 3.9 14.663 3 12.184 3 8.602 3 5.48 4.98 4.01 7.95 3.367 9.21 3 10.56 3 12s.367 2.79 1.01 4.05C5.48 19.02 8.602 21 12.184 21c2.48 0 4.592-.81 6.06-2.16C19.99 17.31 21 14.97 21 12.18c0-.72-.092-1.26-.184-1.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.851faad614c437dbe10cb55569dd86e8.svg";
export { ForwardRef as ReactComponent };